<script setup lang="ts">
import { nodeViewProps, NodeViewWrapper } from '@tiptap/vue-3'
import { computed, ref, Ref } from 'vue'
import { assemble } from '@/composables/charts/influx-charts/chart-builders/ChartFactory'
import CustomNodeEditMenu, { EditNodeDialogPayload } from '@/components/wysiwyg-components/nodes/CustomNodeEditMenu.vue'
import { SerializedChartType } from '@/composables/charts/influx-charts/chart-builders/ChartInterfaces'
import ChartCreatorDialog from '@/components/charts/chart-creator/ChartCreatorDialog.vue'

const props = defineProps(nodeViewProps)

const serializedChart: Ref<SerializedChartType | null | undefined> = ref(props.node.attrs.serialized)

const chartComponent = computed(() => assemble(props.node.attrs.serialized))

const saveChart = (nodeProps: EditNodeDialogPayload) => {
  nodeProps.onUpdate({ serialized: serializedChart.value })
  nodeProps.onSave()
  nodeProps.updateEditNodeDialog(false)
}
</script>

<template>
  <node-view-wrapper
    as="div"
    class="d-block"
  >
    <CustomNodeEditMenu
      :selected="props.selected"
      :variant-parameters="props.node.attrs"
      current-variant="chart-block"
      :variants="[
        { tag: 'inline-chart', label: 'Inline', icon: 'mdi-text' },
        { tag: 'chart-block', label: 'Block', icon: 'mdi-chart-line' },
      ]"
      :node-props="props"
    >
      <template #element="nodeProps">
        <component
          :is="chartComponent"
          v-bind="nodeProps"
        />
      </template>
      <template #nodeEditor="nodeProps">
        <ChartCreatorDialog
          v-model:chart="serializedChart"
          v-model:show-chart-dialog="nodeProps.editNodeDialog"
          is-edit-mode
          hide-actions
          @update:show-chart-dialog="value => nodeProps.updateEditNodeDialog(value ?? false)"
          @save="saveChart(nodeProps)"
        />
      </template>
    </CustomNodeEditMenu>
  </node-view-wrapper>
</template>

<style scoped></style>
